class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));

    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      this.mainDetailsToggle.addEventListener('mouseenter', () => {
        this.mainDetailsToggle.setAttribute('open', '');
      });
      this.mainDetailsToggle.addEventListener('mouseleave', () => {
        this.mainDetailsToggle.removeAttribute('open');
      });
    }
  }

  onToggle() {}

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.close();
      }
    });
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      this.mainDetailsToggle.addEventListener('mouseenter', () => {
        this.mainDetailsToggle.setAttribute('open', '');
      });
      this.mainDetailsToggle.addEventListener('mouseleave', () => {
        this.mainDetailsToggle.removeAttribute('open');
      });

      // Klick auf summary → navigiere zur URL
      const summary = this.mainDetailsToggle.querySelector('summary');
      const overlayLink = this.querySelector('.header__menu-item-overlay-link');
      const href = overlayLink ? overlayLink.getAttribute('href') : null;

      if (href && href !== '#') {
        summary.addEventListener('click', (evt) => {
          evt.preventDefault();
          evt.stopImmediatePropagation();
          window.location.href = href;
        }, true);
      }
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
